exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".session-details[data-v-229a8362] {\n  font-size: 18px;\n  font-style: normal;\n}\n.session-details div[data-v-229a8362]:not(:last-child) {\n  margin-bottom: 5px;\n}", ""]);

// exports
